import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { MetricsResponse, MetricsArgs } from "@/types/metrics";
import { useAppState } from "@/contexts/app-state";
import { useMetricsContext } from "@/contexts/metrics-context";
import { buildApiUrl } from "@/utils/api";

const getMetrics = async (params: MetricsArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().post<MetricsResponse>(buildApiUrl("users/metrics"), {
    filters: params.filters,
  },
  {
    params: {
      practiceId: params.practiceId,
      bucketName: params.bucketName,
      requestedUser: params.requestedUser
    }
  });
  return data;
};

export const useMetrics = ({ bucketName }: {bucketName: string;}) => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;
  const { filters } = useMetricsContext();


  return useQuery<MetricsResponse, Error>({
    queryKey: ["metrics", bucketName, practiceId, requestedUser, filters],
    queryFn: () => getMetrics({ practiceId, requestedUser, bucketName, filters }),
  });
};
